const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const MIDNIGHT_UTC = /^(\d{4}-\d{2}-\d{2})T00:00:00(\.0+)?(Z|\+00:00)?$/;

export function formatDate(value) {
  if (!value) return "—";
  const date = typeof value === "string" && DATE_ONLY.test(value) ? new Date(`${value}T00:00:00`) : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateTime(value) {
  if (!value) return "—";
  if (typeof value === "string") {
    if (DATE_ONLY.test(value)) return formatDate(value);
    const m = MIDNIGHT_UTC.exec(value);
    if (m) return formatDate(m[1]);
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
}

export function timeAgo(value) {
  if (!value) return "";
  const diff = Date.now() - new Date(value).getTime();
  const minutes = Math.round(diff / 60000);
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days} d ago`;
  return formatDate(value);
}

export function formatScore(value, digits = 1) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "—";
  return String(Number(Number(value).toFixed(digits)));
}

export function initials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

export function pluralize(count, word, plural) {
  return `${count} ${count === 1 ? word : plural || `${word}s`}`;
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function firstName(name = "") {
  return name.split(" ")[0] || name;
}
